import vmClient from 'app/services/vmClient';
import { Image, IImage } from 'app/constants/schemas/Image';
import { Sound, ISound } from 'app/constants/schemas/Sound';
import { SentenceTranslation, ISentenceTranslation } from 'app/constants/schemas/SentenceTranslation';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

export interface ILocalSentence extends IEntity {
  attributes: {
    id: EntityStringId;
    text: string;
    transliteration: string | null;
  };
  associations: {
    image: IImage | null;
    sound: ISound | null;
    translations: ISentenceTranslation[];
  };
}

export type LocalSentence = Entity<ILocalSentence>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocalSentence: IEntityType<ILocalSentence> = vmClient.defineClass({
  typeName: 'LocalSentence',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {
    text: {
      type: 'string',
      notNull: true,
    },
    transliteration: 'string',
  },
  associations: {
    image: Image,
    sound: Sound,
    translations: {
      type: SentenceTranslation,
      collection: true,
      notNull: true,
    },
  },
});
